var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1040_10331)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1040_10331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8908 28.7063C11.6298 28.7063 9.79053 30.5435 9.79053 32.8018V38.9291H11.8201V32.8015C11.8201 31.6611 12.749 30.7333 13.8908 30.7333H17.9921V28.7061H13.8908V28.7063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.968 28.7065H41.9072V30.7338H45.968C47.1097 30.7338 48.0386 31.6616 48.0386 32.802V38.9293H50.0682V32.8018C50.0682 30.5437 48.2289 28.7065 45.968 28.7065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78613 41.2766V50.295C9.78613 50.8683 10.2516 51.3333 10.8256 51.3333C11.3996 51.3333 11.8651 50.8683 11.8651 50.295V41.2766C11.8651 40.7032 11.3996 40.2383 10.8256 40.2383C10.2516 40.2381 9.78613 40.703 9.78613 41.2766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47353 44.2006L14.0457 49.1123C14.5271 49.4245 15.1711 49.288 15.4837 48.8069C15.7964 48.3261 15.6597 47.6828 15.178 47.3706L7.60584 42.4591C7.12443 42.1469 6.48046 42.2834 6.16783 42.7645C5.8552 43.2453 5.99189 43.8883 6.47353 44.2006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.178 44.2006L7.60584 49.1125C7.12443 49.4248 6.48046 49.2882 6.16783 48.8071C5.8552 48.3263 5.99189 47.6831 6.47353 47.3708L14.0457 42.4591C14.5271 42.1469 15.1711 42.2834 15.4837 42.7645C15.7964 43.2453 15.6595 43.8883 15.178 44.2006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5356 41.2766V50.295C22.5356 50.8683 23.0011 51.3333 23.5751 51.3333C24.1491 51.3333 24.6146 50.8683 24.6146 50.295V41.2766C24.6146 40.7032 24.1491 40.2383 23.5751 40.2383C23.0011 40.2381 22.5356 40.703 22.5356 41.2766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2226 44.2003L26.7948 49.112C27.2762 49.4243 27.9201 49.2877 28.2328 48.8067C28.5454 48.3258 28.4087 47.6826 27.9271 47.3703L20.3549 42.4586C19.8734 42.1464 19.2295 42.2829 18.9169 42.764C18.6042 43.2451 18.7409 43.8881 19.2226 44.2003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9271 44.2003L20.3549 49.112C19.8734 49.4243 19.2295 49.2877 18.9169 48.8067C18.6042 48.3258 18.7409 47.6826 19.2226 47.3703L26.7948 42.4586C27.2762 42.1464 27.9201 42.2829 28.2328 42.764C28.5454 43.2451 28.4085 43.8881 27.9271 44.2003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2847 41.2766V50.295C35.2847 50.8683 35.7502 51.3333 36.3242 51.3333C36.8982 51.3333 37.3636 50.8683 37.3636 50.295V41.2766C37.3636 40.7032 36.8982 40.2383 36.3242 40.2383C35.7502 40.2381 35.2847 40.703 35.2847 41.2766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.972 44.2003L39.5442 49.112C40.0256 49.4243 40.6696 49.2877 40.9822 48.8067C41.2949 48.3258 41.1582 47.6826 40.6765 47.3703L33.1043 42.4586C32.6229 42.1464 31.9789 42.2829 31.6663 42.764C31.3537 43.2451 31.4906 43.8881 31.972 44.2003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6766 44.2003L33.1044 49.112C32.623 49.4243 31.979 49.2877 31.6664 48.8067C31.3537 48.3258 31.4904 47.6826 31.9721 47.3703L39.5443 42.4586C40.0257 42.1464 40.6696 42.2829 40.9823 42.764C41.2949 43.2451 41.158 43.8881 40.6766 44.2003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0342 41.2766V50.295C48.0342 50.8683 48.4997 51.3333 49.0737 51.3333C49.6477 51.3333 50.1132 50.8683 50.1132 50.295V41.2766C50.1132 40.7032 49.6477 40.2383 49.0737 40.2383C48.4994 40.2381 48.0342 40.703 48.0342 41.2766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.721 44.2003L52.2932 49.112C52.7746 49.4243 53.4186 49.2877 53.7312 48.8067C54.0439 48.3258 53.9072 47.6826 53.4255 47.3703L45.8533 42.4586C45.3719 42.1464 44.728 42.2829 44.4153 42.764C44.1027 43.2451 44.2396 43.8881 44.721 44.2003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4256 44.2003L45.8534 49.112C45.372 49.4243 44.728 49.2877 44.4154 48.8067C44.1028 48.3258 44.2394 47.6826 44.7211 47.3703L52.2933 42.4586C52.7747 42.1464 53.4187 42.2829 53.7313 42.764C54.0439 43.2451 53.9072 43.8881 53.4256 44.2003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8536 19.9077H22.0459C20.6589 19.9077 19.5347 21.0306 19.5347 22.416V33.6127C19.5347 34.6528 20.1772 35.585 21.15 35.9559C23.9836 37.0366 26.9667 37.577 29.9499 37.577C32.933 37.577 35.9162 37.0366 38.7497 35.9559C39.7225 35.5848 40.3651 34.6526 40.3651 33.6127V22.416C40.3648 21.0306 39.2406 19.9077 37.8536 19.9077ZM30.9947 29.1572V31.9879C30.9947 32.5645 30.5269 33.0318 29.9496 33.0318C29.3724 33.0318 28.9046 32.5645 28.9046 31.9879V29.1572C28.0625 28.764 27.4788 27.9107 27.4788 26.9208C27.4788 25.5578 28.5851 24.4531 29.9494 24.4531C31.314 24.4531 32.42 25.5581 32.42 26.9208C32.4204 27.9107 31.8367 28.764 30.9947 29.1572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9639 11.4654V18.6868H25.5432V12.4548C25.5432 11.7855 26.0865 11.2428 26.7565 11.2428H33.1022C33.7723 11.2428 34.3156 11.7855 34.3156 12.4548V18.6868H36.8949V11.4654C36.8949 9.91973 35.6402 8.6665 34.0928 8.6665H25.7662C24.2185 8.6665 22.9639 9.91973 22.9639 11.4654Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1040_10331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "matrix(-1 0 0 1 58 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1040_10331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.8994,
    height: 42.6667,
    fill: "white",
    transform: "translate(6 8.6665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfa);
export default __webpack_public_path__ + "static/media/MFA.520702534a19ba67d7f7f17bcc7fe0cc.svg";
export { ForwardRef as ReactComponent };